import React from 'react'
import Moment from 'react-moment';

class List_video extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id
        }
    }

    onChange = (e) => {
        this.setState({
            id: e.target.value
        })
    }

    render() {
        if (this.props.listVideo.loading) return 'Video loading...';
        if (this.props.listVideo.error) return `Video Error: ${this.props.listVideo.error.message}`;
        let video = this.props.listVideo.getListVideo;
       if(video.length > 0) {
           const video_view = video.map((video, index) => {
               return (
                   <div className="unit" key={index}>
                       <div className="img">
                           <a>
                               <img src={video.img} alt="" className="img-responsive"/>
                               <img src="images/icon-play2.png" alt="" className="play"/>
                           </a>
                       </div>
                       <a className="name">{video.name}</a>
                       <div className="time"><Moment format="hh:ss A DD.MM.YY ">{new Date(video.created_date)}</Moment>
                       </div>
                   </div>
               )
           });
           return (
               <div>
                   {video_view}
               </div>
           )
       } else {
               return (
                   <div  style={{  marginTop: '10px',color: '#FFF'}}>
                       Không có Video
                   </div>
               )
       }

    }

}
export default List_video


// WEBPACK FOOTER //
// ./src/components/Video/List_video.js